import { FunctionComponent } from "react";
import NAV from "../components/NAV";

const Lesson19: FunctionComponent = () => {
  return (
    <div className="relative bg-gray-100 w-full overflow-hidden flex flex-col items-center justify-center p-[2.69rem] box-border gap-[6.88rem] text-left text-[1.56rem] text-darkgray font-nunito">
      <NAV dimensionCode="/nav@2x.png" navIconFlexShrink="unset" />
      <div className="self-stretch flex flex-row items-center justify-between">
      <a className="cursor-pointer text-darkgray no-underline" href={"/lesson18"}>
        <div className="flex-1 rounded-32xl bg-gainsboro-200 box-border h-[3.5rem] flex flex-col items-center justify-center py-[0.69rem] px-[3rem] max-w-[12.5rem] border-[1px] border-solid border-gray-300">
          <b className="relative inline-block w-[3.75rem] h-[2.06rem] shrink-0">
            Back
          </b>
        </div>
        </a>
        <div className="self-stretch flex-1 flex flex-col items-center justify-center text-center text-[2.81rem] text-white">
          <b className="self-stretch relative leading-[100%]">
            Best Fitness Tools
          </b>
        </div>
        <a className="cursor-pointer text-darkgray no-underline" href={"/lesson20"}>
        <div className="flex-1 rounded-32xl bg-gainsboro-200 box-border h-[3.5rem] flex flex-col items-center justify-center py-[0.69rem] px-[3rem] max-w-[12.5rem] border-[1px] border-solid border-gray-300">
          <b className="relative inline-block w-[3.75rem] h-[2.06rem] shrink-0">
            Next
          </b>
        </div>
        </a>
      </div>
      <div className="self-stretch flex flex-col items-center justify-center gap-[11.38rem] text-justify text-gainsboro-100 font-dm-sans">
        <div className="self-stretch flex flex-row items-center justify-center gap-[11.38rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <p className="m-0 text-[1.88rem] text-white">
              <b>Weight Scale</b>
            </p>
            <p className="m-0">&nbsp;</p>
            <p className="m-0">
              The weight scale is a ubiquitous item found in most households,
              much like the television. Interestingly, both sources of
              information can be misleading. It is common for individuals to
              develop an unhealthy attachment to the scale and place significant
              importance on specific weight values.
            </p>
            <p className="m-0">&nbsp;</p>
            <p className="m-0">
              It's important to understand that weight alone reveals little
              about the composition of the body. Weight gain can signify various
              factors, including pure fat gain, pure muscle gain, a combination
              of fat and muscle gain, or a substantial increase in muscle
              accompanied by a slight reduction in fat (resulting in overall
              weight increase).
            </p>
            <p className="m-0">&nbsp;</p>
            <p className="m-0">&nbsp;</p>
            <p className="m-0">&nbsp;</p>
          </div>
          <img
            className="relative w-[35.06rem] h-[31.81rem] object-cover"
            alt=""
            src="/33@2x.png"
          />
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[11.38rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <p className="m-0 text-[1.88rem] text-white">
              <b>Measuring Tape</b>
            </p>
            <p className="m-0">&nbsp;</p>
            <p className="m-0">
              Waist Circumference: Measuring the waist helps determine fat loss
              progress. For instance, if your body weight is increasing while
              your waist circumference is decreasing, it indicates reliable
              evidence of simultaneous muscle gain and fat loss, resulting in a
              reshaped body.
            </p>
            <p className="m-0">&nbsp;</p>
            <p className="m-0">
              In the context of body recomposition, waist measurements are a
              more dependable indicator of fat loss compared to measurements of
              other body parts.
            </p>
            <p className="m-0">&nbsp;</p>
            <p className="m-0">&nbsp;</p>
            <p className="m-0">&nbsp;</p>
          </div>
          <img
            className="relative w-[35.06rem] h-[31.81rem] object-cover"
            alt=""
            src="/34@2x.png"
          />
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[11.38rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <p className="m-0 text-[1.88rem] text-white">
              <b>Food Scale</b>
            </p>
            <p className="m-0">&nbsp;</p>
            <p className="m-0">
              Monitoring your macronutrient (fat, carbohydrate, and protein)
              intake is a highly effective method for manipulating body
              composition. We will provide detailed recommendations for
              macronutrient intake, so it is crucial to accurately track what
              you consume.
            </p>
            <p className="m-0">&nbsp;</p>
            <p className="m-0">
              It is essential to track your protein, fat, and carbohydrate
              intake from all the foods you eat. Foods with nutrition labels
              should provide a specified weight corresponding to each serving
              size. For foods without labels (such as fruits and vegetables),
              you can easily find their nutritional information on various apps
              like MyFitnessPal.
            </p>
            <p className="m-0">&nbsp;</p>
            <p className="m-0">&nbsp;</p>
            <p className="m-0">&nbsp;</p>
          </div>
          <img
            className="relative w-[35.06rem] h-[31.81rem] object-cover"
            alt=""
            src="/35@2x.png"
          />
        </div>
      </div>
      <a className="cursor-pointer text-darkgray no-underline" href={"/lesson20"}>
        <div className="rounded-32xl bg-gainsboro-200 box-border w-[25rem] flex flex-col items-center justify-center pt-[0.69rem] px-[3rem] pb-[1rem] max-w-[31.25rem] text-center text-[1.88rem] border-[1px] border-solid border-gray-300">
          <b className="self-stretch relative">Next Chapter</b>
        </div>
      </a>
    </div>
  );
};

export default Lesson19;
